"use client";
import React, { useState } from "react";
import { useEffectOnce, useEventListener } from "usehooks-ts";

import useBlobity from "../components/shared/blobity/useBlobity.ts";

import Blur from "../components/shared/overlay/Blur.tsx";
import Color from "../components/shared/overlay/Color.tsx";

import NavBar from "../components/pages/homepage/sections/NavBar.tsx";
import Hero from "../components/pages/homepage/sections/Hero.tsx";
import About from "../components/pages/homepage/sections/About.tsx";
import Work from "../components/pages/homepage/sections/Work.tsx";
import Contact from "../components/pages/homepage/sections/Contact.tsx";
import Tools from "../components/pages/homepage/sections/Tools.tsx";
import { Toaster } from "@/components/ui/toaster.tsx";

export default function Home() {
  const [, setIsMobile] = useState(false); //isMobile

  useEffectOnce(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
    setIsMobile(window.innerWidth < 768);
  });

  useEventListener("resize", () => {
    setIsMobile(window.innerWidth < 768);
  });

  useBlobity({
    licenseKey: "opensource",
    focusableElementsOffsetX: 4,
    focusableElementsOffsetY: 4,
    color: "#ffffff",
    dotColor: "#ffffff",
    invert: true,
    focusableElements:
      "[data-blobity], a:not([data-no-blobity]), li:not([data-no-blobity]), button:not([data-no-blobity]), [data-blobity-tooltip]",
    font: "'Inter', sans-serif",
    fontSize: 16,
    fontWeight: 900,
    opacity: 1.0,
    fontColor: "#ffffff",
    zIndex: 35,
    size: 50,
    radius: 5,
    magnetic: false,
  });

  return (
    <>
      {/* <PreLoader /> */}
      <Blur />
      <Color />
      <NavBar />
      <main className="flex flex-col items-center justify-center bg-black">
        <Hero />
        <About />
        <Work />
        <Tools />
        <Contact />
        {/* <Footer /> */}
      </main>
      <Toaster />
    </>
  );
}
